import React, { useEffect } from "react";

import { Col, Container, Button, Row } from "reactstrap";

import { connect } from "react-redux";
import { requestClass } from "../../../redux/actions/class_request_form";
import { fetchSubjectsByQualification } from "../../../redux/actions/api_subject";
import { createLoadingSelector } from "../../../redux/selectors";

import ImageJumbotron from "../../../components/ImageJumbotron";
import PackageCard from "../../../components/PackageCard";
import BottomBar from "../../../components/BottomBar";
import { Bell } from "react-feather";
import { getQualId } from "../../../helpers/qualificationIdentifier";

import Loader from "../../../components/Loader";

const IELTS = ({
  fetchSubjectsByQualification,
  requestClass,
  history,
  isLoading,
  subjects,
}) => {
  useEffect(() => {
    const id = getQualId("ielts");
    fetchSubjectsByQualification(id);
  }, [fetchSubjectsByQualification]);

  const handleClick = () => {
    requestClass({ id: getQualId("ielts"), name: "IELTS" });
    history.push("/page/class/request");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <ImageJumbotron bg="banner5.jpg">
        <Container className="product_container">
          <Row>
            <Col md={6} sm={12}>
              <h1>IELTS / TOEFL</h1>
              <h4>1:1 Online Class</h4>
              <p>
                <span className="highlight">고등 과정 준비의 기초</span>가 되는
                만큼 탄탄한 공부를 통해 고등 과정에 대한{" "}
                <span className="highlight">이해력을 높이는 것</span>이{" "}
                <span className="highlight">가장 중요합니다</span>.
              </p>
              <p>
                전반적으로 명문대학을 목표로 하는 학생들은 8 – 11개의 과목을
                수료하고, 이 과정은{" "}
                <span className="highlight">
                  A-Level을 공부하기 위한 기반이 됩니다
                </span>
                .
              </p>
              <p>
                저희 <span className="highlight">오버더문</span>에서는{" "}
                <span className="highlight">맞춤형 컨설팅</span>을 통해 학생의{" "}
                <span className="highlight">특성, 목표 대학교, 장래희망</span>
                등을 고려해서{" "}
                <span className="highlight">강사님을 매칭해드립니다.</span>
              </p>
              <p>
                해외 곳곳에 위치한{" "}
                <span className="highlight">명문대 출신</span> 강사님들을 통해
                <span className="highlight"> 1:1 맞춤형</span> 온라인 강의를
                받아보세요.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <PackageCard
                subjects={subjects}
                qualification="IGCSE"
                classMethod="비대면"
                targetAudience="중학생 (2,3학년)"
                onClick={handleClick}
              />
            </Col>
          </Row>
        </Container>
      </ImageJumbotron>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
      <div className="site-section mt-0 pt-4">
        <Container className="class-page">
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>IELTS, TOEFL</h2>
                <hr />
              </div>
              <div className="row">
                <div className="col-md-6">
                  IELTS란 International English Language Testing System의 약자로
                  영어권 대학, 전문직 협회, 기업에 들어가기 위해 필요한 영어
                  능력 평가 시험입니다. IELTS 시험 성적은 전세계적으로 인정 받는
                  만큼 많은 사람들이 시험에 응모하고 공부합니다. 대부분의 영국
                  명문대학교는 GCSE/IGCSE 성적이 없는 학생들을 상대로 영어
                  실력의 검증을 위해 IELTS Academic의 시험 성적을 요구합니다.
                </div>
                <div className="col-md-6">
                  <img
                    src={require("../../../assets/img/IELTS_logo.png")}
                    className="img-fluid"
                    alt=" "
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  TOEFL은 Test of English as a Foreign Language 의 약자로 영어를
                  모국어로 하지 않는 사람들을 상대로 학문적인 영어구사능력을
                  평가하는 시험입니다. 미국이나 캐나다, 오스트레일리아 등 영어권
                  나라의 대학, 대학원을 입학할 때 영어로 수업을 받을 수 있는지를
                  평가합니다. 또한 정부 기관이나 자격증, 기업, 장학금 등에도 이
                  시험의 점수가 필요하고, 시험 점수의 유효기간은 2년입니다.
                  테스트하는 분야는 읽기(Reading), 듣기(Listening)
                  쓰기(Writing), 말하기(Speaking) 입니다.
                </div>
                <div className="col-md-6">
                  <img
                    src={require("../../../assets/img/TOEFL_logo.png")}
                    className="img-fluid"
                    alt=" "
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>오버더문 수업 진행 절차</h2>
            <hr />
            <p className="text-center">
              <img
                src={require("../../../assets/img/IELTS_process.png")}
                className="img-fluid"
                alt=" "
              />
            </p>
          </div>
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>IELTS 시험 구성</h2>
                <hr />
              </div>
              <div className="col-md-12 text-center">
                <img
                  src={require("../../../assets/img/IELTS_exam.png")}
                  className="img-fluid"
                  alt=" "
                />
              </div>
            </div>
          </div>
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>TOEFL 시험 구성</h2>
                <hr />
              </div>
              <div className="col-md-12 text-center">
                <img
                  src={require("../../../assets/img/TOEFL_exam.png")}
                  className="img-fluid"
                  alt=" "
                />
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>상담 문의</h2>
            <hr />
            <p className="text-center">
              <a
                href="https://pf.kakao.com/_xdNrsT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../../assets/img/kakaoplus.png")}
                  className="img-fluid"
                  alt="kakaoplus"
                />
              </a>
            </p>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const loadingSelector = createLoadingSelector(["FETCH_SUBJECTS"]);

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  subjects: state.api_subject.subjects,
});

const mapDispatchToProps = (dispatch) => ({
  requestClass: (class_type) => dispatch(requestClass(class_type)),
  fetchSubjectsByQualification: (qualification) =>
    dispatch(fetchSubjectsByQualification(qualification)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IELTS);
